import React from 'react';
import { useTreatmentWithAttr } from '../../hooks/split';
import LightWeightVersion from '../../v2/components/independent-adjusters/lightWeightVersion';
import NormalVersion from '../../v2/components/independent-adjusters/normalVersion';

const IndependentAdjusters = () => {
  const treatment = useTreatmentWithAttr('hover-static-independent-adj-split');

  return treatment === 'on' ? <NormalVersion /> : <LightWeightVersion />;
};

export default IndependentAdjusters;
